import api from './api';

const notesService = {
  // Get all notes
  getAll: () => api.get('/notes'),

  // Create note
  create: (data) => api.post('/notes', data),

  // Update note
  update: (id, data) => api.put(`/notes/${id}`, data),

  // Delete note
  delete: (id) => api.delete(`/notes/${id}`)
};

export default notesService;
